module.exports = __webpack_public_path__ + "img/37fed0355edf4cff5a3558125ac2787e.png";